import { config } from '@config';
import ReactGA from 'react-ga4';

export const initializeGoogleAnalytics = () => {
  if (config.googleAnalytics?.measurementId) {
    ReactGA.initialize(config.googleAnalytics.measurementId);
  }
};
